import React, { forwardRef } from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import { EsimTooltip } from "designSystem/Tooltips";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "100%",
		position: "relative",
		backgroundColor: theme.palette.colors.white,
		border: `1px solid ${theme.palette.colors.disabled}`,
		borderTop: "none",
		boxShadow: "inset 0 -5px 5px 0 rgba(0, 0, 0, 0.05)",
		display: "flex",
		"&:last-child": {
			borderRadius: "0 0 10px 10px",
			boxShadow: "none",
		},
	},
	cell: {
		borderRight: `1px solid ${theme.palette.colors.disabled}`,
		padding: "22px 36px",
		"&:last-child": {
			borderRight: "none",
		},
	},
	tariffInfoCell: {
		width: "335px",
		position: "relative",
	},
	tooltipEsim: {
		top: "24px",
		right: "8px",
		position: "absolute",
		cursor: "pointer",
	},
	measureCell: {
		width: "175px",
		textAlign: "center",
		padding: "22px 20px !important",
	},
	minCell: {},
	gbCell: {},
	unlimitedSocialCell: {
		display: "none",
	},
	priceCell: {},
	buttonsCell: {
		width: "318px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		rowGap: "10px",
	},
	logo: {},
	buttons: {},
	tariffNameMargin: {},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		cell: {
			padding: "22px 33px",
		},
		tariffInfoCell: {
			width: "305px",
		},
		measureCell: {
			width: "135px",
			textAlign: "center",
			padding: "22px 16px !important",
		},
		buttonsCell: {
			width: "228px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		cell: {
			padding: "16px 25px",
		},
		tariffInfoCell: {
			width: "200px",
		},
		tooltipEsim: {
			top: "15px",
		},
		measureCell: {
			width: "110px",
			textAlign: "center",
			padding: "16px 5px !important",
		},
		buttonsCell: {
			width: "180px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			borderTop: `1px solid ${theme.palette.colors.disabled}`,
			boxShadow: "none",
			display: "flex",
			borderRadius: "10px",
			flexWrap: "wrap",
			marginBottom: "16px",
			borderBottom: "none",
			"&:first-child": {
				borderRadius: "10px",
			},
			"&:last-child": {
				borderRadius: "10px",
				boxShadow: "none",
			},
		},
		cell: {
			padding: "15px 30px",
			borderRight: "none",
			borderBottom: `1px solid ${theme.palette.colors.disabled}`,
			"&:last-child": {
				borderRight: "none",
				borderBottom: "none",
			},
		},
		tariffInfoCell: {
			width: "100%",
		},
		tooltipEsim: {
			top: "-19px",
			right: "unset",
		},
		measureCell: {
			width: "50%",
			textAlign: "left",
		},
		minCell: {
			padding: "15px 9px 15px 30px !important",
		},
		gbCell: {
			padding: "15px 30px 15px 9px !important",
		},
		unlimitedSocialCell: {
			display: "block",
			flexGrow: 1,
			padding: "15px 30px !important",
		},
		priceCell: {
			padding: "15px 30px!important",
			width: "100%",
		},
		buttonsCell: {
			width: "100%",
			flexDirection: "column-reverse",
			alignItems: "center",
			display: "flex",
			padding: 0,
		},
		logo: {
			display: "block",
			position: "absolute",
			right: "20px",
			top: "9px",
		},
		buttons: {
			width: "100%",
		},
		tariffNameMargin: {
			marginTop: "30px",
		},
	},
}));

const TarifficationMItem = forwardRef(
	(
		{
			eliteComponent,
			tariffInfo,
			minutesComponent,
			gbComponent,
			unlimitedSocial,
			buttons,
			priceComponent,
			logoComponent,
			esim,
			esimText,
		},
		ref
	) => {
		const classes = useStyles();
		return (
			<div ref={ref} className={classes.root}>
				{eliteComponent && <div>{eliteComponent}</div>}
				<div className={classNames(classes.tariffInfoCell, classes.tariffNameMargin, classes.cell)}>
					{tariffInfo}
					{esim && <EsimTooltip content={esimText}>{esim}</EsimTooltip>}
				</div>
				<div className={classNames(classes.measureCell, classes.cell, classes.minCell)}>
					{minutesComponent}
				</div>
				<div className={classNames(classes.measureCell, classes.cell, classes.gbCell)}>
					{gbComponent}
				</div>
				{!!unlimitedSocial && (
					<div
						className={classNames(classes.measureCell, classes.cell, classes.unlimitedSocialCell)}
					>
						{unlimitedSocial}
					</div>
				)}
				<div className={classNames(classes.measureCell, classes.cell, classes.priceCell)}>
					{priceComponent}
				</div>
				<div className={classNames(classes.buttonsCell, classes.cell)}>
					<div className={classes.logo}>{logoComponent}</div>
					<div className={classes.buttons}>{buttons}</div>
				</div>
			</div>
		);
	}
);

export default TarifficationMItem;
